module.exports = __webpack_public_path__ + "static/media/SOUTHERN DOWNS REGIONAL.9ad20c3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_areas/SOUTHERN DOWNS REGIONAL.svg
// module id = 582
// module chunks = 0